<script>
  import { onMount } from 'svelte';
  import { default as NewsletterForm } from './newsletter_form.svelte';
  
  
  
  //onMount();
</script>
<div class='container my-4'>
<div class='row mb-4'>
<div class='col-12 col-lg-6'>
<div class='card feature d-flex flex-column h-100'>
<div class='row'>
<div class='col-sm-5'>
<img alt='Vyhledávání' class='card-img' src='/img/info/search.jpg'>
</div>
<div class='col-sm-7 justify-content-between'>
<div class='d-flex flex-column'>
<div class='card-body mt-2'>
<h4 class='card-title'>Vyhledávání</h4>
</div>
<div class='card-body'>
<p class='card-text font-italic'>Hledáte prodejce vína, vinárnu nebo vinný sklípek s&nbsp;ubytováním?</p>
<p class='card-text'>Na&nbsp;DEMIJÓN.CZ máte k&nbsp;dispozici přehled obchodů a&nbsp;vinařů v&nbsp;celém Jihomoravském kraji.</p>
</div>
<div class='card-body'>
<a alt='Vyhledávání' class='btn btn-lg btn-block btn-outline-dark stretched-link' href='/firmy' title='Vyhledávání'>
<span class='mr-1 font-weight-bold'>VYHLEDÁVAT</span>
<i class='fa fa-chevron-right'></i>
</a>
</div>
</div>
</div>
</div>
</div>
</div>
<div class='col-12 col-lg-6'>
<div class='card feature d-flex flex-column h-100'>
<div class='row'>
<div class='col-sm-5'>
<img alt='Registrace pro firmy' class='card-img' src='/img/info/somelier.jpg'>
</div>
<div class='col-sm-7'>
<div class='d-flex flex-column justify-content-between'>
<div class='card-body mt-2'>
<h4 class='card-title'>Prodej</h4>
</div>
<div class='card-body'>
<p class='card-text font-italic'>Prodáváte víno, příslušenství nebo pronajímáte vinný sklep?</p>
<p class='card-text'>DEMIJÓN.CZ nabízí základní profil zdarma a&nbsp;pokročilé funkce za&nbsp;lidové ceny.</p>
</div>
<div class='card-body'>
<a alt='Pokračovat' class='btn btn-lg btn-block btn-outline-dark stretched-link' href='/html/prihlaseni.html' title='Pokračovat'>
<span class='mr-1 font-weight-bold'>Prodávat</span>
<i class='fa fa-chevron-right'></i>
</a>
</div>
</div>
</div>
</div>
</div>
</div>
</div>

</div>
<div class='container my-4 pt-4' id='newsletter'>
<div class='row my-4'>
<div class='col'>
<div class='jumbotron'>
<h1 class='display-5'>Odběr novinek</h1>
<p class='lead'>Portál DEMIJÓN.CZ se neustále vyvíjí. Buďte informováni o novinkách!</p>
<p>Připravujeme nové funkce, profily vinařů a pozvánky na nadcházející akce spojené s vínem.</p>
<NewsletterForm form_id='9155f653-97fe-4796-a934-aff375b204b7'></NewsletterForm>
</div>
</div>
</div>
</div>
<div class='container my-4'>
<div class='container my-4 py-4'>
<div class='row'>
<div class='col-12'>
<h3>Doporučená vinařství a vinotéky</h3>
</div>
</div>
<div class='row main-row my-2'>
<div class='col-12 col-md-6 col-lg-4'>
<div class='card pricing mb-3 overflow-hidden my-2 shadow h-700' style='max-width: 100%'>
<div class='row m-0'>
<div class='d-flex align-items-center justify-content-center col-md-12 pt-sm-0 pt-md-0 company-bg h-200 text-center' style='background-image: url(/img/vines-100.jpg);'>
<img alt='Naše Vinotéka B' class='img-fluid my-3 my-md-5' src='/img/logo.jpg' title='Naše Vinotéka B'>
</div>
<div class='col-md-12'>
<div class='card-body justify-content-start'>
<h3 class='card-title text-dark font-weight-bold'>Vinařství Neckařovi</h3>
<h5 class='mb-3 card-text text-dark font-weight-normal'>Šumperk, Langrova&nbsp;12</h5>
<ul class='list-inline'>
<li class='list-inline-item' title='Otevírací doba'>
<span class='badge badge-dark p-2'>
<span class='h6'>
<span class='fa fa-clock-o'></span>
<span>denně 9-16</span>
</span>
</span>
</li>
<li class='list-inline-item' title='Vína'>
<span class='badge badge-success p-2'>
<span class='h6'>
<span class='fa fa-glass'></span>
<span>24</span>
</span>
</span>
</li>
<li class='list-inline-item' title='Kapacita'>
<span class='badge badge-success p-2'>
<span class='h6'>
<span class='fa fa-user'></span>
<span>50</span>
</span>
</span>
</li>
<li class='list-inline-item' title='Ubytování'>
<span class='badge badge-success p-2'>
<span class='h6'>
<span class='fa fa-bed'></span>
<span>30</span>
</span>
</span>
</li>
<li class='list-inline-item' title='Pobočky'>
<span class='badge badge-success p-2'>
<span class='h6'>
<span class='fa fa-home'></span>
<span>5</span>
</span>
</span>
</li>
<li class='list-inline-item' title='Galerie'>
<span class='badge badge-success p-2'>
<span class='h6'>
<span class='fa fa-camera'></span>
<span>10</span>
</span>
</span>
</li>
<li class='list-inline-item' title='Popularita'>
<span class='badge badge-success p-2'>
<span class='h6'>
<span class='fa fa-heart'></span>
<span>128</span>
</span>
</span>
</li>
</ul>
<p class='card-text font-normal text-body'>Předáváme Vám emoce ve&nbsp;výborném a&nbsp;kvalitním víně už&nbsp;od&nbsp;roku 2008 a&nbsp;jsme velká rodina, která se&nbsp;neustále rozrůstá.</p>
<a alt='Více' class='btn btn-block btn-outline-dark' href='/firmy' title='Více'>
<span class='mr-1 font-weight-bold'>VÍCE</span>
<i class='fa fa-chevron-right'></i>
</a>
</div>
</div>
</div>
</div>
</div>
<div class='col-12 col-md-6 col-lg-4'>
<div class='card pricing mb-3 overflow-hidden my-2 shadow h-700' style='max-width: 100%'>
<div class='row m-0'>
<div class='d-flex align-items-center justify-content-center col-md-12 pt-sm-0 pt-md-0 company-bg h-200 text-center' style='background-image: url(/img/bottle-1.jpg);'>
<img alt='Naše Vinotéka C' class='img-fluid my-3 my-md-5' src='/img/neckar-logo.png' title='Naše Vinotéka C'>
</div>
<div class='col-md-12'>
<div class='card-body justify-content-start'>
<h3 class='card-title text-dark font-weight-bold'>Vinařství Neckařovi</h3>
<h5 class='mb-3 card-text text-dark font-weight-normal'>Šumperk, Langrova&nbsp;12</h5>
<ul class='list-inline'>
<li class='list-inline-item' title='Otevírací doba'>
<span class='badge badge-dark p-2'>
<span class='h6'>
<span class='fa fa-clock-o'></span>
<span>denně 9-16</span>
</span>
</span>
</li>
<li class='list-inline-item' title='Vína'>
<span class='badge badge-success p-2'>
<span class='h6'>
<span class='fa fa-glass'></span>
<span>24</span>
</span>
</span>
</li>
<li class='list-inline-item' title='Kapacita'>
<span class='badge badge-success p-2'>
<span class='h6'>
<span class='fa fa-user'></span>
<span>50</span>
</span>
</span>
</li>
<li class='list-inline-item' title='Ubytování'>
<span class='badge badge-success p-2'>
<span class='h6'>
<span class='fa fa-bed'></span>
<span>30</span>
</span>
</span>
</li>
<li class='list-inline-item' title='Pobočky'>
<span class='badge badge-success p-2'>
<span class='h6'>
<span class='fa fa-home'></span>
<span>5</span>
</span>
</span>
</li>
<li class='list-inline-item' title='Galerie'>
<span class='badge badge-success p-2'>
<span class='h6'>
<span class='fa fa-camera'></span>
<span>10</span>
</span>
</span>
</li>
<li class='list-inline-item' title='Popularita'>
<span class='badge badge-success p-2'>
<span class='h6'>
<span class='fa fa-heart'></span>
<span>128</span>
</span>
</span>
</li>
</ul>
<p class='card-text font-normal text-body'>Předáváme Vám emoce ve&nbsp;výborném a&nbsp;kvalitním víně už&nbsp;od&nbsp;roku 2008 a&nbsp;jsme velká rodina, která se&nbsp;neustále rozrůstá.</p>
<a alt='Více' class='btn btn-block btn-outline-dark' href='/sites/demijon.cz/html/detail.html' title='Více'>
<span class='mr-1 font-weight-bold'>VÍCE</span>
<i class='fa fa-chevron-right'></i>
</a>
</div>
</div>
</div>
</div>
</div>
<div class='col-12 col-md-6 col-lg-4'>
<div class='card pricing mb-3 overflow-hidden my-2 shadow h-700' style='max-width: 100%'>
<div class='row m-0'>
<div class='d-flex align-items-center justify-content-center col-md-12 pt-sm-0 pt-md-0 company-bg h-200 text-center' style='background-image: url(/img/grapes-2.jpg);'>
<img alt='Naše Vinotéka D' class='img-fluid' src='/img/logo.jpg' title='Naše Vinotéka D'>
</div>
<div class='col-md-12'>
<div class='card-body justify-content-start' style='max-height: 100%'>
<h3 class='card-title text-dark font-weight-bold'>Naše Vinotéka</h3>
<h5 class='mb-3 card-text text-dark font-weight-normal'>Šumperk, Langrova&nbsp;12</h5>
<ul class='list-inline'>
<li class='list-inline-item' title='Otevírací doba'>
<span class='badge badge-dark p-2'>
<span class='h6'>
<span class='fa fa-clock-o'></span>
<span>denně 9-16</span>
</span>
</span>
</li>
<li class='list-inline-item' title='Vína'>
<span class='badge badge-success p-2'>
<span class='h6'>
<span class='fa fa-glass'></span>
<span>24</span>
</span>
</span>
</li>
<li class='list-inline-item' title='Kapacita'>
<span class='badge badge-success p-2'>
<span class='h6'>
<span class='fa fa-user'></span>
<span>50</span>
</span>
</span>
</li>
<li class='list-inline-item' title='Ubytování'>
<span class='badge badge-success p-2'>
<span class='h6'>
<span class='fa fa-bed'></span>
<span>30</span>
</span>
</span>
</li>
<li class='list-inline-item' title='Pobočky'>
<span class='badge badge-success p-2'>
<span class='h6'>
<span class='fa fa-home'></span>
<span>5</span>
</span>
</span>
</li>
<li class='list-inline-item' title='Galerie'>
<span class='badge badge-success p-2'>
<span class='h6'>
<span class='fa fa-camera'></span>
<span>10</span>
</span>
</span>
</li>
<li class='list-inline-item' title='Popularita'>
<span class='badge badge-success p-2'>
<span class='h6'>
<span class='fa fa-heart'></span>
<span>128</span>
</span>
</span>
</li>
</ul>
<p class='card-text font-normal text-body'>Předáváme Vám emoce ve&nbsp;výborném a&nbsp;kvalitním víně už&nbsp;od&nbsp;roku 2008 a&nbsp;jsme velká rodina, která se&nbsp;neustále rozrůstá.</p>
<a alt='Více' class='btn btn-block btn-outline-dark' href='/firmy' title='Více'>
<span class='mr-1 font-weight-bold'>VÍCE</span>
<i class='fa fa-chevron-right'></i>
</a>
</div>
</div>
</div>
</div>
</div>
</div>
</div>

</div>

